<template>
  <section>
    <Feature :title="$t('RESIN_REFERENCE_PRICE_MAINTAIN')" :iconClass="'fa-database'">
      <FormRowTwo
        :fieldNameArr="[$t('RESIN_VENDOR'), $t('RESIN_DISTRIBUTOR'), $t('VALID_FROM'), $t('VALID_TO'), $t('LOG')]"
        :fieldWidthArr="[414, 434, 364, 414, 364]" :fieldSpanWidthArr="[152, 172, 102, 152, 52]">
        <Select class="Input" v-model="resinVendorName" @on-change="changeResinVendors($event)"
          :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in resinVendors" :value="item.vendorName" :key="item.id">
            {{ item.vendorName }}
          </Option>
        </Select>
        <Select class="Input" v-model="resinPartNoDesc" @on-change="changeResinPartNo($event)" :placeholder="$t('CHOOSE')"
          slot="b">
          <Option v-for="(item) in resinNos" :value="item.partNoDesc" :key="item.id">
            {{ item.partNoDesc }}
          </Option>
        </Select>
        <DatePicker class="Input" v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')"
          slot="c"></DatePicker>
        <DatePicker class="Input" v-model="validTo" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')"
          slot="d"></DatePicker>
        <i-switch v-model="isLog" slot="e"></i-switch>
      </FormRowTwo>
      <ButtonRow>
        <Button type="primary" @click="search(true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="clear" slot="2">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <Feature v-show="existedPriceList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
        <Button type="primary" @click="download">{{ $t('DOWNLOAD') }}</Button>
        <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="priceList" :pageObj="pageObj"
          @changePage="changePage"></TablePage>
      </Feature>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky
      :draggable="true" v-model="model" :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, ExceptionHandling, DateToString } from "@/util/common"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "ResinReferencePriceMaintain",
  components: {
    FormRowTwo
  },
  created() {
    const vueInstance = this
    vueInstance.$getReferenceData(vueInstance, "/resin-reference-price/find/vendor").then(data => {
      vueInstance.resinVendors = data.sort(function (a, b) {
        return a.vendorName.localeCompare(b.vendorName, "en");
      });
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
    vueInstance.$getReferenceData(vueInstance, "/resin-reference-price/find/resinNo").then(data => {
      vueInstance.resinNos = data.sort(function (a, b) {
        return a.partNoDesc.localeCompare(b.partNoDesc, "en");
      });
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
  },
  data() {
    return {
      model: false,
      file: null,
      validFrom: null,
      validTo: null,
      isLog: false,
      resinVendorName: '',
      resinVendor: {},
      resinVendors: [],
      resinPartNoDesc: '',
      resinNo: {},
      resinNos: [],
      priceList: [],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('RESIN_VENDOR')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "vendorCode",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RESIN_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "vendorName",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RESIN_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "partNo",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "description",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "currency",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "price",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validFrom",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validTo",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_GROUP_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "createGroupAccount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "created",
          sortable: true
        },
        {
          title: this.$t('ENABLED'),
          width: 60,
          align: "center",
          render: (h, params) => {
            let value = params.row["enabled"] ? "YES" : "NO"
            return h("span", {}, value)
          },
          width: 110
        },
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    clear() {
      const vueInstance = this
      vueInstance.validFrom = null
      vueInstance.validTo = null
      vueInstance.resinNo = {}
      vueInstance.resinPartNoDesc = ""
      vueInstance.resinVendor = {}
      vueInstance.resinVendorName = ""
    },
    changeResinVendors(value) {
      this.resinVendor = this.resinVendors.find(function (resinVendor) {
        return resinVendor.vendorName == value
      });
    },
    changeResinPartNo(value) {
      this.resinNo = this.resinNos.find(function (resinNo) {
        return resinNo.partNoDesc == value
      });
    },
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post('/resin-reference-price/search?sort=vendor&sort=resinNo&sort=currency&sort=validFrom&page='
          + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCriteria(vueInstance)))
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.priceList = []
          if (response.data._embedded != undefined) {
            let data = response.data
            vueInstance.priceList = data._embedded.resinReferencePriceResourceList
            vueInstance.pageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch(() => { })
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'ResinReferencePrice')
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$quotationHttp
        .post("/resin-reference-price/uploadExcel", fd)
        .then((response) => {
          this.file = null
          this.model = false
          this.search(true)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    download() {
      this.$downloadExcel(this, "resin-reference-price", buildCriteria(this), "?sort=vendor&sort=resinNo&sort=currency&sort=validFrom")
    },
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    existedPriceList() {
      return this.priceList && this.priceList.length > 0
    },
  },
  watch: {
    resinVendorName: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    resinPartNoDesc: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    validFrom: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    validTo: {
      handler() {
        this.priceList = []
      },
      immediate: true
    }
  }
}

function buildCriteria(vueInstance) {
  return {
    "resinPartNoId": JSON.stringify(vueInstance.resinNo) != '{}' && vueInstance.resinNo != null ? vueInstance.resinNo.uuid : null,
    "resinVendorId": JSON.stringify(vueInstance.resinVendor) != '{}' && vueInstance.resinVendor != null ? vueInstance.resinVendor.uuid : null,
    "validFrom": vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    "validTo": vueInstance.validTo != "" && vueInstance.validTo != null ? DateToString(vueInstance.validTo, "-") : null,
    "enabled": !vueInstance.isLog
  }
}

</script>

<style scoped></style>
